import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-file-new-built-folder",
  "use": "icon-file-new-built-folder-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-file-new-built-folder\"><defs><style type=\"text/css\"></style></defs><path d=\"M928 745.6v25.9c0 28.6-23.2 51.9-51.9 51.9H149.9c-28.6 0-51.9-23.2-51.9-51.9V252.8c0-28.6 23.2-51.9 51.9-51.9H430l83 77.8h332c45.6 0 83 35 83 77.8v389.1zM513 408.4c-21.5 0-38.9 17.4-38.9 38.9v77.8h-77.8c-21.5 0-38.9 17.4-38.9 38.9s17.4 38.9 38.9 38.9h77.8v77.8c0 21.5 17.4 38.9 38.9 38.9s38.9-17.4 38.9-38.9v-77.8h77.8c21.5 0 38.9-17.4 38.9-38.9s-17.4-38.9-38.9-38.9h-77.8v-77.8c0-21.5-17.4-38.9-38.9-38.9z\" p-id=\"13702\" fill=\"#546e7a\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/file-new-built-folder.svg
// module id = NYCM
// module chunks = 22